import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const HelpPage = lazy(() => import('src/pages/help'));
const TrainingVideosPage = lazy(() => import('src/pages/training-videos'));

// ----------------------------------------------------------------------

export const helpRoutes = [
  {
    path: 'help',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'quicklinks', element: <HelpPage />, index: true },
      { path: 'training-videos', element: <TrainingVideosPage /> },
    ],
  },
];
